<div *ngIf="agentMode" class="govuk-width-container">
	<button type="button" class="btn btn-primary" data-module="govuk-button" (click)="datastoreService?.agentRestart()">
		Agent Restart
	</button>
</div>

<div class="row breadcrumb-container">
	<div class="col-12">
		<div class="govuk-width-container">
			<govuk-ui-breadcrumb [items]="breadcrumbItems"></govuk-ui-breadcrumb>
		</div>
	</div>
</div>
<div class="govuk-width-container">

	<div class="row m-0">
		<div class="col-sm-12 p-0">
			<gb-ui-back-link (back)="routerGoBack()"></gb-ui-back-link>
		</div>
	</div>
</div>
<main id="main-content" tabindex="-1">
	<div class="row page-heading-container">
		<div class="col-12">
			<gb-ui-page-heading [titleText]="pageTitle ">
				<ng-template #subContent>
					<p>
						The time you select below is the time your ceremony begins, <strong>not</strong> the time
						your guests or the
						registrars arrive.
					</p>
				</ng-template>
			</gb-ui-page-heading>
		</div>
	</div>
	<div class="govuk-width-container">
		<div class="govuk-main-wrapper govuk-main-wrapper--l">
			<ng-container *ngIf="selectedDepartment">
				<app-mat-calendar [service]="selectedService" [location]="selectedLocation" [component]="component"
					[slotSelectionError]="slotSelectionError" [noMoreDates]="noMoreDates" class="row m-0"
					(selectSlotUpdate)="slotSelected($event)" (noMoreDatesError)="onNoMoreDatesError($event)">
				</app-mat-calendar>

				<div class="row summary-row">
					<h2 *ngIf="this.datastoreService.selectSlot" class="col-sm-12 col-md-8 col-lg-9 center-content"
						style="padding: 0;">Date and time</h2>
					<div class="col-sm-12 col-md-8 col-lg-9 center-content">
						@if(this.datastoreService.selectSlot) {
						<p tabindex="0" class="body-bold" role="status" aria-live="polite">
							<span class="label">You've selected</span>
							{{ this.datastoreService.selectSlot.displayTime}}
							on
							{{ this.datastoreService.selectSlot.datetime | date : 'EEEE d MMMM' }}.
							<span class="govuk-visually-hidden"
								aria-label="selected time, {{ this.datastoreService.selectSlot.displayTime }}">
								{{ this.datastoreService.selectSlot.displayTime }}
							</span>
							<span class="govuk-visually-hidden"
								aria-label="selected date, {{ this.datastoreService.selectSlot.datetime | date : 'EEEE d MMMM' }}">
								{{ this.datastoreService.selectSlot.datetime | date : 'EEEE d MMMM' }}
							</span>
						</p>
						} @else {
						@if(noMoreDates) {
						<p tabindex="0" class="body-bold">{{ 'COMMON.CEREMONY_NO_FUTURE_DATES' | translate }}</p>
						}
						@else {
						<p tabindex="0" class="body-bold">
							Please select a time slot to continue.
						</p>
						}
						}
					</div>
					<h2 *ngIf="this.datastoreService.selectSlot" class="col-sm-12 col-md-8 col-lg-9 center-content"
						style="padding: 0;">Ceremony fee</h2>
					<div *ngIf="this.datastoreService.selectSlot" class="col-sm-12 col-md-8 col-lg-9 center-content">
						<p tabindex="0" class="body-bold">
							<span class="label" role="status" aria-live="polite">The total ceremony fee for the selected
								date and time is</span>
							{{this.datastoreService.storedFee?.full_fee | currency:'GBP':'symbol':'1.2-2'}}
						</p>
					</div>

					<div class="col-sm-12 col-md-8 col-lg-9 center-content">
						<button *ngIf="selectedDepartment && !noMoreDates" type="submit"
							class="btn btn-primary btn-next float-end" (click)="continue()">
							{{ 'COMMON.NEXT' | translate }}
						</button>
					</div>

				</div>
			</ng-container>
		</div>
	</div>
</main>